import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "w-[260px]" };
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "flex items-center" };
import ESelect from '@common/ui/ESelect/ESelect.vue';
import EMenuItem from '@common/ui/EMenu/EMenuItem.vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangeLang',
    setup: function (__props) {
        var locale = useI18n().locale;
        // const { locale  } = useI18n({ useScope: 'global' })
        var localeCurrent = ref(locale.value);
        var localeOptions = [
            {
                value: 'ru',
                label: 'Русский',
                meta: {
                    img: '/img/common/components/footer/russia.png'
                }
            },
            {
                value: 'en',
                label: 'English',
                meta: {
                    img: '/img/common/components/footer/united-kingdom.png'
                }
            },
            {
                value: 'kk',
                label: 'Қазақша',
                meta: {
                    img: '/img/common/components/footer/kk.png'
                }
            },
            {
                value: 'uz',
                label: "O'zbekcha",
                meta: {
                    img: '/img/common/components/footer/uz.png'
                }
            },
            {
                value: 'es',
                label: 'Español',
                meta: {
                    img: '/img/common/components/footer/es.png'
                }
            },
            {
                value: 'it',
                label: 'Italiano',
                meta: {
                    img: '/img/common/components/footer/it.png'
                }
            },
            {
                value: 'de',
                label: 'Deutsch',
                meta: {
                    img: '/img/common/components/footer/de.png'
                }
            },
            {
                value: 'fr',
                label: 'Français',
                meta: {
                    img: '/img/common/components/footer/fr.png'
                }
            }
        ];
        var currentOptions = computed(function () { return localeOptions.find(function (l) { return l.value === localeCurrent.value; }); });
        var localChange = function () {
            locale.value = localeCurrent.value;
            localStorage.setItem('locale', localeCurrent.value);
            //обновляю приложение после смены языка
            window.location.reload();
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ESelect, {
                    modelValue: localeCurrent.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((localeCurrent).value = $event); }),
                    options: localeOptions,
                    class: "mb-5",
                    size: "large",
                    theme: "white",
                    onChange: localChange
                }, {
                    prepend: _withCtx(function () {
                        var _a, _b;
                        return [
                            _createElementVNode("img", {
                                src: (_b = (_a = currentOptions.value) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.img,
                                class: "w-5 h-5 mr-1"
                            }, null, 8, _hoisted_2)
                        ];
                    }),
                    option: _withCtx(function () { return [
                        _hoisted_3
                    ]; }),
                    additionalAfter: _withCtx(function (_a) {
                        var isSelected = _a.isSelected, onOptionClick = _a.onOptionClick;
                        return [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localeOptions, function (recently) {
                                return _createVNode(EMenuItem, {
                                    key: recently.value,
                                    "is-selected": isSelected(recently),
                                    onSelect: function ($event) { return (onOptionClick(recently)); }
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("img", {
                                            src: recently.meta.img,
                                            class: "w-5 h-5 mr-4"
                                        }, null, 8, _hoisted_4),
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(recently.label), 1)
                                    ]; }),
                                    _: 2
                                }, 1032, ["is-selected", "onSelect"]);
                            }), 64))
                        ];
                    }),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
